<template>
  <div></div>
<!--  <div class="aside-comment-keyboard-component">
    <div class="comment-keyboard">
      <span class="keyboard-title d-flex align-center justify-space-between">
        Редактировать комментарий
        <button @click="hideCommentKeyboard" class="button-close">
          <font-awesome-icon icon="times" />
        </button>
      </span>
      <v-keyboard
        v-model="comment"
        @onClose="hideCommentKeyboard"
        class="keyboard"
        closable
        id="courierCommentKeyboard"
      />
    </div>
  </div>-->
</template>

<script>
  import { mapState } from 'vuex'
  import VKeyboard from './Keyboard'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'AsideCommentKeyboard',
    mixins: [mixinSnackbarMessage],
    components: {
      VKeyboard,
    },
    data () {
      return {}
    },
    watch: {
      currentStep () {
        this.hideCommentKeyboard()
      },
    },
    computed: {
      ...mapState({
        courierComment: (state) => state.newOrder.courierComment,
        basket: (state) => state.baskets.basket,
        currentStep: (state) => state.newOrder.currentStep,
      }),
      comment: {
        get () {
          return this.courierComment
        },
        set (value) {
          if (value !== this.courierComment) {
            this.updateBasketComment(value)
          }
        },
      },
    },
    methods: {
      updateBasketComment (value) {
        this.$store.commit('newOrder/setCourierComment', value)
        const data = {
          commentForCourier: this.comment,
        }
        const id = this.basket.id
        clearTimeout(this.courierInputTimeout)
        this.courierInputTimeout = setTimeout(() => {
          this.$store
            .dispatch('baskets/updateBasket', { data, id })
            .then((res) => {
              if (res.status === 200) {
                this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
                this.showSuccessMessage('Комментарий обновлен')
              } else {
                this.showErrorMessage(res.response.data.message)
              }
            })
        }, 1500)
      },
      hideCommentKeyboard () {
        this.$store.commit('newOrder/toggleCommentKeyboard', false)
      },
    },
  }
</script>

<style lang="less" scoped>
.aside-comment-keyboard-component {
  position: fixed;
  left: 326px;
  right: 0;
  bottom: 0;
  max-width: 1149px;
  .comment-keyboard {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);

    .button-close {
      width: 40px;

      svg {
        width: 40px;
        height: 40px;
        vertical-align: middle;
        .fill-svg(#ffffff);
      }
    }

    .keyboard-title {
      color: #ffffff;
      font-size: 24px;
      width: 100%;
      padding: 20px 10px;
    }

    .keyboard {
      width: 100%;
    }
  }
}
</style>
